module.exports = __webpack_public_path__ + "img/header-navigation-below-kia.c0235bf1.png";